<template>
  <!--最外层包裹-->
  <div class="wrap">
     <Topnav></Topnav>
     <div class="zx-wrap">
        <div class="zx-wrap-tab">
          <ul class="zx-wrap-tab-nav">
            <li  v-for="(item,index) in navitem" :key="index"
                 :class="{active:index==current}"
                 @touchend.prevent="handelSwitch(index)" >{{item}}</li>
          </ul>
          <!--<div class="zx-wrap-tab-region">更多地区>>
          </div>
          <ul class="zx-wrap-tab-region-list">
            <li v-for="(item,index) in regionslsit"   :key="index">{{item.deptName}}</li>
          </ul>-->
        </div>
     </div>
     <ul class="zx-list" v-show="datalist.length>0">
      <li class="zx-list-item" v-for="(item,index) in datalist" :key="index">
        <div class="zx-list-item-img" @touchend.prevent="handleHerf(item.basicId)">
          <img :src=item.basicThumbnail alt="">
        </div>
        <p class="zx-list-item-text text-tow-overflow" @touchend.prevent="handleHerf(item.basicId)"  v-html="item.basicTitle" :title=item.basicTitle>
          {{item.basicTitle}}
        </p>
      </li>
      <paging :dataall="remembrancepage.all" :dataCur="remembrancepage.cur" :datanum="remembrancepage.num" :dataDatanum="remembrancepage.dataNum"
              @change="pageChange"></paging>
    </ul>
     <div v-show="datalist.length<=0" class="zx-wrap-tab-zw">
      暂无数据...
     </div>
  </div>
</template>
<script>
  stopTouchendPropagationAfterScroll();
  function stopTouchendPropagationAfterScroll(){
    var locked = false;
    window.addEventListener('touchmove', function(ev){
      locked || (locked = true, window.addEventListener('touchend', stopTouchendPropagation, true));
    }, true);
    function stopTouchendPropagation(ev){
      ev.stopPropagation();
      window.removeEventListener('touchend', stopTouchendPropagation, true);
      locked = false;
    }
  }
</script>
<script>
  import {RECOLLECTION,REMINISCENCE,MOSTSOUGHT} from '@/config/global.js'
  import {getUserToken} from '@/config/config.js'
  import util from '@/assets/js/util'
  import Paging from '@/components/paging.vue'
  import Topnav from '@/components/topnav.vue'
  import {getzyJsondata, getzsJsondata, getzxJsondata, getzyAjaxdata,gethotareaJsondata} from '@/api/Remembrance.js'
  export default {
    data() {
      return {
        current:'',
        navitem:["追忆","追思","追寻"],
        /*json 数据*/
        basicAreaCode:"",
        regionslsit:"",
        screenfourdata: [],
        columnId:"",
        zydata: [],
        zsdata: [],
        zxdata: [],
        datalist:[],
        remembrancepage:{
          all: '', //总页数
          cur: 1, //当前页码
          num: 6, //一页显示的数量  必须是奇数
          dataNum: '', //数据的数量
        }
      }
    },
    mounted() {
      util.stopTouchendPropagationAfterScroll();
      this._handleObtainData(1);
      this._handHoTarea()
    },
    methods: {
      /*切换栏目*/
      /* index:1.追忆 2.追思 3.追寻
      * 1.判断当前栏目是否有值
      * 2.没有请求json 赋值
      * 3.有取值填充
      * */
      _handleObtainData(index) {
        if (index == 1) {
          this.columnId = RECOLLECTION
          if (util.isEmpty(this.zydata)) {
            getzyJsondata().then(res => {
              if (!util.isEmpty(res)) {
                this.zydata = util.getJsonDetails(res, this.remembrancepage.num)
                this.remembrancepage.dataNum = res[0].pageSize
                this.remembrancepage.all = Math.ceil(res[0].pageSize / this.remembrancepage.num)
                this.Recollection = true
                this.Reminiscence = false
                this.pursue = false;
                this.sothelist = this.zydata;
                this.remembrancepage.cur = 1
                this.datalist = this.sothelist['1'];
              } else {
                this.remembrancepage.cur = 1
                this.Recollection = true
                this.Reminiscence = false
                this.pursue = false;
                this.datalist =[]
              }
            }).catch((err) => {
              this.Recollection = true
              this.Reminiscence = false
              this.pursue = false;
              this.datalist =[]
            })
          } else {
            this.remembrancepage.dataNum = this.zydata['1'][0].pageSize
            this.remembrancepage.all =  Math.ceil((this.zydata['1'][0].pageSize/this.remembrancepage.num)<=0?1:(this.zydata['1'][0].pageSize/this.remembrancepage.num))
            this.remembrancepage.cur = 1;
            this.Recollection = true
            this.Reminiscence = false
            this.pursue = false
            this.sothelist = this.zydata
            this.remembrancepage.cur = 1
            this.datalist = this.sothelist['1']
            console.log(this.datalist + '11')
          }
          return
        }
        if (index == 2) {
          this.columnId = REMINISCENCE
          if (util.isEmpty(this.zsdata)) {
            getzsJsondata().then(res => {
              if (!util.isEmpty(res)) {
                this.zsdata = util.getJsonDetails(res, this.remembrancepage.num);
                this.remembrancepage.dataNum = res[0].pageSize;
                this.remembrancepage.all = Math.ceil(res[0].pageSize / this.remembrancepage.num)
                this.sothelist = this.zsdata;
                this.datalist = this.sothelist['1']
                this.remembrancepage.cur = 1
                console.log(this.datalist + '2')
              } else {
                this.remembrancepage.cur = 1
                this.datalist =[]
              }
            }).catch((err) => {
              this.datalist =[]
              console.log(err, "2")
            })
          } else {
            this.remembrancepage.dataNum = this.zsdata['1'][0].pageSize
            this.remembrancepage.all =Math.ceil((this.zsdata['1'][0].pageSize/this.remembrancepage.num)<0?1:this.zsdata['1'][0].pageSize/this.remembrancepage.num)
            this.sothelist = this.zsdata
            this.remembrancepage.cur = 1
            this.datalist = this.sothelist['1']
            console.log(this.datalist + '22')
          }
          return
        }
        if (index == 3) {
          this.columnId = MOSTSOUGHT;
          if (util.isEmpty(this.zxdata)) {
            getzxJsondata().then(res => {
              if (!util.isEmpty(res)) {
                this.zxdata = util.getJsonDetails(res, this.remembrancepage.num);
                this.remembrancepage.cur = 1
                this.remembrancepage.dataNum = res[0].pageSize;
                this.remembrancepage.all = Math.ceil(res[0].pageSize / this.remembrancepage.num)
                this.sothelist = this.zxdata
                this.datalist = this.sothelist['1']
                console.log(this.datalist + '3')
              } else {
                this.remembrancepage.cur = 1
                this.datalist =[]
              }
            }).catch((err) => {
              this.datalist =[]
              console.log(err, "2")
            })
          } else {
            this.remembrancepage.dataNum = this.zxdata['1'][0].pageSize
            this.remembrancepage.all = Math.ceil((this.zxdata['1'][0].pageSize/this.remembrancepage.num)<0?1:this.zxdata['1'][0].pageSize/this.remembrancepage.num)
            this.sothelist = this.zxdata
            this.datalist = this.sothelist['1']
            this.remembrancepage.cur = 1
            console.log(this.datalist + '33')
          }
          return
        }
      },
      //子级传值到父级上来的动态拿去
      /*
      * 1.判断当前页是否大于要取的页数量
      * 2.大于发取json文件  小于发ajax
      * */
      pageChange: function (page) {
        this.remembrancepage.cur = page;
        let data = {
          columnId:this.columnId,
          basicAreaCode: this.basicAreaCode,
          pageSize: this.remembrancepage.num,
          pageNum: this.remembrancepage.cur
        };
        if (!this.sothelist[page] || (this.sothelist[page].length < this.remembrancepage.num)) {
          getzyAjaxdata(data).then((res) => {
            if (res.code == 200 && res.rows) {
              if (res.rows.length > 0) {
                this.datalist = res.rows;
              }else{
                this.datalist = []
              }
            }else {
              this.datalist = []
            }
          }).catch((err) => {
          })
        } else {
          this.datalist = this.sothelist[page];
        }
      },
      handleCity(id){
        this.basicAreaCode = id;
        let data = {
          columnId:this.columnId,
          basicAreaCode: this.basicAreaCode,
          pageSize: this.remembrancepage.num,
          pageNum: 1
        };
        getzyAjaxdata(data).then((res) => {
          if (res.code == 200 && res.rows) {
            if (res.rows.length > 0) {
              this.datalist = res.rows;
              this.remembrancepage.dataNum =res.total;
              this.remembrancepage.all = Math.ceil(res.total/this.remembrancepage.num)
            }else {
              this.datalist = [];
            }
          }else {
            this.datalist = [];
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      handelSwitch(index){
        this.current = index
        this._handleObtainData(index+1)
      },
      _handHoTarea(){
        gethotareaJsondata().then((res)=>{
          this.regionslsit = res
        }).catch(()=>{

        })
      },
      handleHerf(id) {
        let two = this.$router.resolve({
          path: `/Details/${id}&&3`,
        })
        window.open(two.href, '_blank');
      }

    },
    components:{
      Paging,
      Topnav
    }
  }
</script>
<style lang="scss" scoped>
  @import "index.scss";
</style>





// WEBPACK FOOTER //
// src/pages/Remembrance/index.vue